export function emailYardInfoHTML(yardInfo) {
  const {
    businessName,
    street,
    city,
    state,
    zip,
    phoneNumber,
    email,
    website,
    firstName,
    lastName,
    userPhone,
    userEmail,
  } = yardInfo;

  debugger;

  return `<!-- Begin HTML Content -->
        <div style="text-align: left;">
            <strong> Yard Name: ${businessName} <br> </strong>
            Yard Address: ${street}, ${city}, ${state} ${zip} <br>
            Yard Phone #: ${phoneNumber} <br>
            Yard Email: ${email} <br>
            Yard Website: ${website} <br>
            <br>
            <strong> User Name: ${firstName} ${lastName} <br> </strong>
            User Phone #: ${userPhone} <br>
            User Email: ${userEmail} <br>
        </div>
        <br>
        <br>
        <!-- End HTML Content -->`;
}
